import { observable, action, computed, intercept } from "mobx";
import { post } from "../services/ajax.service";
import numeral from "numeral";
import NumeralHelper from "../helpers/NumeralHelper";
class PcmSavingsStore {
  @observable not_found = false;
  @observable max_saving = 0;
  @observable current_drug_cost = 0;
  @observable alternatives = 0;
  @observable proposed_drug_cost = 0;
  @observable participant_savings = [];
  @observable average_therapeutic_savings = [];
  @observable participant_count = 0;
  @observable min_date = ""
  @observable max_date = ""
  @observable drug_count = 0;
  @observable life_count = 0;
  @observable saving_count = 0;
  @observable employee_count = 0;
  @observable claims_count = 0;
  @observable claim_cost = 0;
  @observable url = "/api/v1/recommendationActions/pcmsaving";
  @observable percentage_cost = {
    thirty: 0,
    fourty: 0,
    fifty: 0,
    sixty: 0
  }

  constructor() {
    intercept(this, change => {
      if (change.newValue == null || change.newValue == 0) {
        localStorage.setItem("not_found", true)
      } else if (change.newValue != null || change.newValue != 0) {
        localStorage.setItem("not_found", false)
      }
      return change;
    })
  }
  @computed get project_savings() {
    return (
      NumeralHelper(this.max_saving * 0.5, "large-money") + " - " + NumeralHelper(this.max_saving * 0.6, "large-money")
    );
  }
  @computed get THIRTY_PERCENT() {
    return this.max_saving * 0.3 * 0.7752;
  }
  @computed get FOURTY_PERCENT() {
    return this.max_saving * 0.4 * 0.7752;
  }

  @computed get FIFTY_PERCENT() {
    return this.max_saving * 0.5 * 0.7752;
  }

  @computed get SIXTY_PERCENT() {
    return this.max_saving * 0.6 * 0.7752;
  }


  @action setIt = () => {
    this.not_found = true
  }
  @action getMaxSavings = async data => {
    this.max_saving = 0;
    try {
      let response = await post(
        `${this.url}/getMaxSavings`,
        data
      );

      this.max_saving = response.data[0].MAXIMUM_SAVINGS || 0;
      this.participant_count = response.data[0].unique_par || 0
      this.drug_count = response.data[0].drug_count || 0
      this.min_date = response.data[0].min_date || ""
      this.max_date = response.data[0].max_date || ""
    } catch (err) {
      console.log(err);
    }
  };


  @action getCurrentDrugCost = async data => {
    this.current_drug_cost = 0;
    try {
      let response = await post(
        `${this.url}/getCurrentDrugCost`,
        data
      );

      this.current_drug_cost = response.data[0].CURRENT_DRUG_COST;
      this.claim_cost = response.data[0].claim_cost;
      this.alternatives = response.data[0].alternatives;
    } catch (err) {
      console.log(err);
    }
  };


  @action getProposedDrugCost = async data => {
    this.proposed_drug_cost = 0;
    try {
      let response = await post(
        `${this.url}/getProposedDrugCost`,
        data
      );

      this.proposed_drug_cost = response.data[0].PROPOSED_DRUG_COST;
    } catch (err) {
      console.log(err);
    }
  };


  @action getParticipantSavings = async data => {
    this.participant_savings = [];
    try {
      let response = await post(
        `${this.url}/getParticipantSavings`,
        data
      );
      this.participant_savings = response.data;
    } catch (err) {
      console.log(err);
    }
  };


  @action getAverageTherapeuticSavings = async data => {
    this.average_therapeutic_savings = [];
    try {
      let response = await post(
        `${this.url}/getAverageTherapeuticSavings`,
        data
      );

      this.average_therapeutic_savings = response.data;
    } catch (err) {
      console.log(err);
    }
  };


  @action getLifeCount = async data => {
    this.life_count = 0;
    try {
      let response = await post(
        `${this.url}/getLifeCount`,
        data
      );

      this.life_count = response.data[0].LIFE_COUNT;
    } catch (err) {
      console.log(err);
    }
  };


  @action getEmployeeCount = async data => {
    this.employee_count = 0;
    try {
      let response = await post(
        `${this.url}/getEmployeeCount`,
        data
      );

      this.employee_count = response.data[0].EMPLOYEE_COUNT;
    } catch (err) {
      console.log(err);
    }
  };

  @action getTotalClaims = async data => {
    this.claims_count = 0;
    try {
      let response = await post(
        `${this.url}/getTotalClaims`,
        data
      );

      this.claims_count = response.data[0].TOTAL_CLAINS;
    } catch (err) {
      console.log(err);
    }
  };


  @action getTotalSavings = async data => {
    this.saving_count = 0;
    try {
      let response = await post(
        `${this.url}/getTotalSavings`,
        data
      );
      this.saving_count = response.data[0].TOTAL_SAVINGS;
    } catch (err) {
      console.log(err);
    }
  };

  @action getPercentagesCost = async data => {
    this.percentage_cost = {
      thirty: 0,
      fourty: 0,
      fifty: 0,
      sixty: 0
    };
    try {
      let response = await post(
        `${this.url}/getPercentagesCost`,
        data
      );

      this.percentage_cost.thirty = response.data[0].THIRTY;
      this.percentage_cost.fourty = response.data[0].FOURTY;
      this.percentage_cost.fifty = response.data[0].FIFTY;
      this.percentage_cost.sixty = response.data[0].SIXTY;
    } catch (err) {
      console.log(err);
    }
  };

  @action getAnnualizeDate = async data => {
    try {
      let response = await post(
        `${this.url}/getAnnualizeDate`,
        data
      );
      return response.data;
    } catch (err) {
      console.log(err);
    }
  }

}

export default PcmSavingsStore;
